import { render, staticRenderFns } from "./content-item.vue?vue&type=template&id=41ea775d&"
import script from "./content-item.vue?vue&type=script&lang=js&"
export * from "./content-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports